import { IIndexable } from '../model/IIndexable';
import { PreguntaData } from '@bpba/modules-components';

export function faqMapping(item: IIndexable) {
  return new PreguntaData(item.id, item.pregunta, item.respuesta, item.video);
}
